<template>
  <el-container class="rights-card-box" direction="vertical">
    <div class="search-x">
      <div class="search-item">
        <span class="label">权益卡名称</span>
        <el-input v-model.trim="form.cardName" clearable placeholder="请输入" class="input-box" />
      </div>
      <div class="search-item">
        <span class="label">包含服务</span>
        <el-select v-model="form.itemId" clearable filterable placeholder="请选择">
          <el-option v-for="el in itemOptions" :key="el.id" :label="el.itemName" :value="el.id" />
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">状态</span>
        <el-select v-model="form.status" clearable placeholder="请选择">
          <el-option label="启用" value="ON" />
          <el-option label="停用" value="OFF" />
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">白名单手机号</span>
        <el-input v-model.trim="form.whitelistMobile" clearable placeholder="请输入" class="input-box" />
      </div>
      <div class="search-item">
        <span class="label">白名单姓名</span>
        <el-input v-model.trim="form.whitelistName" clearable placeholder="请输入" class="input-box" />
      </div>
      <el-button class="search-btn" v-auth="'sa_rights_card_page'" type="primary" @click="getData(true)">查询</el-button>
      <el-button class="search-btn" type="primary" @click="reset">重置</el-button>
      <el-button class="search-btn" v-auth="'sa_rights_card_page'" type="primary" @click="onExport">批量导出</el-button>
      <el-button class="search-btn" v-auth="'sa_rights_card_create'" type="warning" @click="toPage('rightsCardAdd')">新增</el-button>
    </div>
    <div class="table-box" ref="tableBox">
      <el-table :data="tableData" v-loading="loading" :height="tableHeight || undefined" border>
        <el-table-column prop="cardName" label="权益卡名称" min-width="140" />
        <el-table-column label="时长" width="100">
          <template slot-scope="{ row }">{{ row.defaultDurationDays }}天</template>
        </el-table-column>
        <el-table-column prop="selfItemCount" label="包含本人服务个数" width="140" />
        <el-table-column prop="familyItemCount" label="包含家属服务个数" width="140" />
        <el-table-column prop="whitelistCount" label="白名单人数" width="110" />
        <el-table-column prop="codeTotal" label="已生成" width="90" />
        <el-table-column prop="codeActivated" label="已激活" width="90" />
        <el-table-column prop="codeRemain" label="剩余" width="90" />
        <el-table-column label="创建时间" width="170">
          <template slot-scope="{ row }">{{ formatTime(row.createTime) }}</template>
        </el-table-column>
        <el-table-column prop="statusName" label="状态" width="80" />
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" v-auth="'sa_rights_card_edit'" @click="toPage('rightsCardEdit', { id: row.id })">编辑</el-button>
            <el-button type="text" v-auth="'sa_rights_card_code_page'" @click="toPage('rightsCardCode', { cardId: row.id, cardName: row.cardName })">卡密管理</el-button>
            <el-button type="text" v-auth="'sa_rights_card_whitelist'" @click="toPage('rightsCardWhitelist', { cardId: row.id, cardName: row.cardName })">白名单管理</el-button>
            <el-button type="text" v-auth="'sa_rights_card_status'" @click="toggleStatus(row)">
              {{ row.status === 0 || row.status === 'ON' ? '停用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-x">
        <el-pagination
          @size-change="getData(true)"
          @current-change="getData()"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :page-sizes="[10, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
          background
        />
      </div>
    </div>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { dateFormat } from "@/assets/js/until.js";

export default {
  name: "rightsCard",
  data() {
    return {
      form: {},
      loading: false,
      page: { pageSize: 10, pageNo: 1, total: 0 },
      tableData: [],
      tableHeight: 0,
      itemOptions: [],
    };
  },
  computed: {
    ...mapGetters(["authMap"]),
  },
  created() {
    this.loadItemOptions();
    this.getData(true);
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.tableBox) {
        this.tableHeight = this.$refs.tableBox.offsetHeight - 60;
      }
    });
  },
  methods: {
    formatTime(t) {
      return t ? dateFormat(t, "Y/m/d H:i:s") : "-";
    },
    toPage(name, query = {}) {
      this.$router.push({ name, query });
    },
    reset() {
      this.form = {};
      this.getData(true);
    },
    async loadItemOptions() {
      try {
        const res = await this.axios.get(this.getApiUrl("rightsCardItemOptions"));
        this.itemOptions = res.data || [];
      } catch (e) {
        this.itemOptions = [];
      }
    },
    async getData(reset) {
      if (reset) this.page.pageNo = 1;
      this.loading = true;
      try {
        const res = await this.axios.get(this.getApiUrl("rightsCardPage"), {
          params: {
            ...this.form,
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize,
          },
        });
        const data = res.data || {};
        this.tableData = data.data || [];
        this.page.total = data.total || 0;
      } finally {
        this.loading = false;
      }
    },
    onExport() {
      const qs = Object.keys(this.form || {})
        .filter((k) => this.form[k] !== undefined && this.form[k] !== null && this.form[k] !== "")
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(this.form[k])}`)
        .join("&");
      window.open(this.getApiUrl("rightsCardExport") + (qs ? "?" + qs : ""), "_blank");
    },
    toggleStatus(row) {
      const isOn = row.status === 0 || row.status === "ON";
      const next = isOn ? "OFF" : "ON";
      this.$confirm(`确定${isOn ? "停用" : "启用"}该权益卡？`, "提示", { type: "warning" })
        .then(async () => {
          const res = await this.axios.post(
            this.getApiUrl("rightsCardStatus"),
            { id: row.id, status: next },
            { toJSON: true }
          );
          if (res && res.code === 1) {
            this.$message.success("操作成功");
            this.getData();
          } else {
            this.$message.error((res && res.msg) || "操作失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.rights-card-box {
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
}
.search-x {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 0 12px 8px 0;
}
.search-item .label {
  margin-right: 8px;
  white-space: nowrap;
}
.input-box {
  width: 180px;
}
.search-btn {
  margin: 0 8px 8px 0;
}
.table-box {
  flex: 1;
  overflow: hidden;
}
.page-x {
  margin-top: 12px;
  text-align: right;
}
</style>
